import { NgModule } from '@angular/core';

import { ShareModule } from './shared/share.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {
  LocationStrategy,
  HashLocationStrategy
} from '@angular/common';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    ShareModule,
    AppRoutingModule
  ],
  exports: [],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts